import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './pushtoken.routes';
import addHtml from './modal/add.html';
import _ from 'lodash';

export class PushTokenController {
    $http;
    socket;
    pushtokens = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('pushtoken');
        });
    }

    $onInit() {
        if (this.$cookies.get('token')) {
            this.$http.get('/api/push_tokens/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.pushtokens = response.data.data;
                        this.socket.syncUpdates('pushtokens', this.pushtokens);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }
        const payload = angular.copy(this.filters);



        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/push_tokens/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.pushtokens = response.data.data;

                        this.socket.syncUpdates('pushtokens', this.pushtokens);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    addPushToken() {
        const pushtokens = this.pushtokens;
        this.$uibModal.open({
            template: addHtml,
            size: 'lg',
            /*@ngInject*/
            controller: function ($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.IsSubscribe = [{ value: 0, name: '非定制' }, { value: 1, name: '定制' }];
                $scope.IsPolling = [{ value: 0, name: '否' }, { value: 1, name: '是' }];
                $scope.Hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'];
                $scope.Minutes = ['00', '15', '30', '45'];
                $scope.PushTemplate = [{ value: 1, name: '第一次' }, { value: 2, name: '第二次' }];
                $scope.contentData = [{}];
                $scope.addContent = function () {
                    $scope.contentData.push({});
                };

                $scope.delContent = function (index) {
                    $scope.contentData.splice(index, 1);
                }

                $scope.popup2 = {
                    opened: false
                };

                $scope.open2 = function () {
                    $scope.popup2.opened = true;
                };


                $scope.save = function (myForm) {
                    if (myForm.$valid === false) {
                        return false;
                    } else {
                        let data = {};

                        // let content = [];
                        // let content_data = _.cloneDeep($scope.contentData);
                        // _.map(content_data, function (object) {
                        //     for (const key in object) {
                        //         if (object.hasOwnProperty(key)) {
                        //             const element = object[key];
                        //             console.log(element);
                        //             console.log(element);

                        //         }
                        //     }
                        // })
                        let content = "";
                        if ($scope.vm.content) {
                            content = eval('(' + $scope.vm.content + ')');
                            for (const key in content) {
                                if (content.hasOwnProperty(key)) {
                                    content[key] = content[key].toString();
                                }
                            }
                        }


                        let push_date_time = "";
                        if ($scope.vm.push_date_time) {
                            let date = new Date($scope.vm.push_date_time);
                            let y = date.getFullYear();
                            let m = (date.getMonth() + 1) >= 10 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1);
                            let d = (date.getDate()) >= 10 ? (date.getDate()) : '0' + (date.getDate());
                            push_date_time = '' + y + '-' + m + '-' + d + '';
                        }


                        if ($scope.vm.is_subscribe === 1) {
                            data = {
                                is_subscribe: $scope.vm.is_subscribe,
                                push_date_time: push_date_time,
                                push_Template: $scope.vm.push_Template,
                                push_title: $scope.vm.push_title,
                                push_body: $scope.vm.push_body,
                                content: JSON.stringify(content),
                            }
                        } else {
                            data = {
                                is_subscribe: $scope.vm.is_subscribe,
                                is_polling: $scope.vm.is_polling,
                                push_date: '' + $scope.vm.hours + ':' + $scope.vm.minutes + '',
                                push_date_time: push_date_time,
                                push_title: $scope.vm.push_title,
                                push_body: $scope.vm.push_body,
                                content: content ? JSON.stringify(content) : '',
                            }
                        }


                        $http.post('/api/customs/', data).then((response) => {
                            if (response.status === 200) {
                                $uibModalInstance.close();
                            }
                        }, (error) => {
                            console.log(error);
                        });
                    }
                };
                $scope.cancel = function () {
                    $uibModalInstance.close();
                };
            }
        })
    }
}

export default angular.module('tttApp.pushtoken', [uiRouter])
    .config(routing)
    .component('pushtoken', {
        template: require('./pushtoken.html'),
        controller: PushTokenController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/pushtoken/pushtoken.component.js